export const lowerCaseFirstLetter = (s) => {
    if (typeof s !== 'string')
        return '';
    return s.charAt(0).toLowerCase() + s.slice(1);
};
export const camelize = (str) => {
    if (!str || !str.includes('-')) {
        return str;
    }
    const arr = str.split('-');
    const capital = arr.map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase());
    return lowerCaseFirstLetter(capital.join(''));
};
export const toKebabCase = (str) => str
    .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
    .replace(/ /, '-')
    .replace(/ /, '-')
    .toLowerCase();
export const normalizeDesignTokenName = (key) => toKebabCase(lowerCaseFirstLetter(key)).replace('go-to-', '');
export const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
};
export const applyColorAlpha = (color, alpha) => {
    const { r, g, b } = hexToRgb(color);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
const normalizeValue = (value, key) => {
    // Wrap the box-shadow with parentheses
    if (key.startsWith('elevation') || key.startsWith('transition')) {
        value = `(${value})`;
    }
    return value;
};
/*
  Removes the duplicate `goto`, and coverts the key of the object to a kebab-case name
*/
export const normalizeKeys = (obj) => {
    const returnValue = {};
    Object.keys(obj).forEach((key) => {
        const normalizedKey = normalizeDesignTokenName(key);
        returnValue[normalizedKey] = normalizeValue(obj[key], normalizedKey);
    });
    return returnValue;
};
